module.exports = __webpack_public_path__ + "img/nuimg.29856681.png";